export const GET_TOKEN_ALLOWANCE = "GET_TOKEN_ALLOWANCE";
export const TOKEN_ALLOWANCE_ERROR = "TOKEN_ALLOWANCE_ERROR";

export const SET_TOKEN_ALLOWANCE = "SET_TOKEN_ALLOWANCE";
export const SET_TOKEN_ALLOWANCE_ERROR = "SET_TOKEN_ALLOWANCE_ERROR";

export const GET_WALLET_BALANCES = "GET_WALLET_BALANCES";
export const ERROR_WALLET_BALANCES = "ERROR_WALLET_BALANCES";
